export function pmcLoadDomain(values: number[]) {
  const finite = values.filter(Number.isFinite);
  const max = Math.max(1, ...finite);
  const step = Math.max(10, Math.ceil(max / 4 / 10) * 10);
  return { min: 0, max: Math.ceil(max / step) * step };
}

export function pmcFormDomain(values: number[]) {
  const finite = values.filter(Number.isFinite);
  return {
    min: Math.floor(Math.min(-10, ...finite) / 10) * 10,
    max: Math.ceil(Math.max(10, ...finite) / 10) * 10,
  };
}

export function nearestPmcTime(times: number[], target: number) {
  return times.reduce((best, time) => Math.abs(time - target) < Math.abs(best - target) ? time : best, times[0]);
}
